import { API, graphqlOperation } from 'aws-amplify'
import {listAuditTemplates, checklistsByAuditTmpl} from '@/graphql/queries.js'
import {updateAuditTemplate, updateChecklistTemplate, createChecklistTemplate} from '@/graphql/mutations'
import { deleteAuditTemplate, deleteChecklistTemplate, createAuditTemplate } from '../../graphql/mutations';
import {v4 as uuidv4 } from 'uuid'

const MAX_ITEMS = 500

export const getChecklistTemplate1 = `query GetChecklistTemplate(
    $id: ID!
    ) {
      getChecklistTemplate(
        id: $id
      ) {
        id
        auditCode
        desc
        questions {
          auditCode
          desc
        }
        sublists(limit:100) {
          items {
            id
            auditCode
            desc
          }
          nextToken
        }
      }
    }
    `;
    
const getAuditTemplate1 = `query GetAuditTemplate(
    $id: ID!
    $limit: Int
    $nextToken: String
    ) {
      getAuditTemplate(
        id: $id
      ) {
        id
        name
        desc
        checklists(limit:$limit, nextToken:$nextToken) {
          items {
            id
            auditCode
            desc
            owner
          }
          nextToken
        }
        owner
        ver
      }
    }
    `;

async function loadChecklistTemplate(id) {
    try {
        const { data: {getChecklistTemplate: template} } = await API.graphql(graphqlOperation(getChecklistTemplate1, {id: id}))
        while(template.sublists.nextToken) {
            const {  data: {getChecklistTemplate: template2} } = await API.graphql(graphqlOperation(getChecklistTemplate1,
                {
                    id: id,
                    nextToken:template.sublists.nextToken}
                ))
            template.sublists.items.push(...template2.sublists.items)
            template.sublists.nextToken = template2.sublists.nextToken
        }
        return template
    }
    catch (err) {
        console.log('error getting audit template: ', err)
    }
}

async function loadAuditTemplate(auditId) {
    if(!auditId)
        return
    try {
        const { data: {getAuditTemplate: template} } = await API.graphql(graphqlOperation(getAuditTemplate1, {id: auditId}))
        while(template.checklists.nextToken) {
            const {  data: {getAuditTemplate: template2} } = await API.graphql(graphqlOperation(getAuditTemplate1,
                {
                    id: auditId,
                    limit:100,
                    nextToken:template.checklists.nextToken},
                ))
            template.checklists.items.push(...template2.checklists.items)
            template.checklists.nextToken = template2.checklists.nextToken
        }
        return template
    }
    catch (err) {
        console.log('error getting audit template: ', err)
    }
}

async function loadTemplates() {
    let templates = []
    var nextToken, items
    do {
        ( { data: { listAuditTemplates: {items, nextToken} } } = await API.graphql(graphqlOperation(listAuditTemplates, {limit:100, nextToken})) )
        templates.push(...items)
    } while(nextToken)
 //   let special = await loadAuditTemplate('7c5b5c98-c9d7-4ebe-acc3-8a20678367e2')
 //   console.log("special", special)
    console.log("templates1", templates)
    let wholeTemplates = templates.map(async (t) => loadAuditTemplate(t.id))

    return Promise.all(wholeTemplates);
}

async function loadAllChecklists(templateId) {
    let checklists = []
    var nextToken, items
    do {
        ({ data: { checklistsByAuditTmpl: { items, nextToken } } } = await API.graphql(graphqlOperation(checklistsByAuditTmpl, {
            auditTmpl: templateId,
            limit: MAX_ITEMS,
            nextToken
        })))
        checklists.push(...items)
    } while (nextToken)
    return checklists
}

async function deleteChecklists(checklists) {
    let delPromises = checklists.map(async(c) => 
        API.graphql(graphqlOperation(deleteChecklistTemplate, {input:{id:c.id}}))
    )
    return Promise.all(delPromises)
}

async function delAuditTemplate(templateId) {
    console.log("deleting template", templateId)
    return await API.graphql(graphqlOperation(deleteAuditTemplate, {input:{id:templateId}}))
}

async function migrateChecklistTemplate(checklistId, templateId, parentId) {
    console.log("updating", checklistId, templateId)
    let checklistTemp = await loadChecklistTemplate(checklistId)
    let sublistPromises = checklistTemp.sublists.items.map(s => migrateChecklistTemplate(s.id, templateId, checklistTemp.id))
    for(var i = 0; i < sublistPromises.length; ++i) {
        await sublistPromises[i]
    }
    let input = {
        id: checklistTemp.id,
        auditTmpl: templateId,
        parent: parentId
    }
    await API.graphql(graphqlOperation(updateChecklistTemplate, {input}))
}

function mapId(idMap, id) {
    if(!idMap[id]){
        idMap[id] = uuidv4();
    }
    return idMap[id]
}

async function copyChecklists(checklists, newTemplateId, oldTemplateId, newOwner) {
    console.log("Copying checklists", checklists, newTemplateId, oldTemplateId, newOwner) 

    let idMap = {}
    idMap[oldTemplateId] = newTemplateId
    let copied = checklists.map(c => {
        console.log("copying", c)
        let newId = mapId(idMap, c.id)
        let newParent = c.parent ? mapId(idMap, c.parent) : undefined
        let newAuditTmplId = mapId(idMap, c.auditTmpl)

        let newChecklist = {
            'id': newId,
            'auditCode': c.auditCode,
            'desc': c.desc,
            'questions': c.questions,
            'parent': newParent,
            'auditTmpl': newAuditTmplId,
            'owner': newOwner
        }
        if(newParent) {
            newChecklist['checklistTemplateSublistsId'] = newParent
        } else {
            newChecklist['auditTemplateChecklistsId'] = newAuditTmplId
        }
        return newChecklist
    })

    console.log("copied checklists", copied)

    let copyPromises = copied.map(async(c) => API.graphql(graphqlOperation(createChecklistTemplate, {input:c})))
    return await Promise.all(copyPromises)
}
async function copyAuditTemplate(newTemplate) {
    return await API.graphql(graphqlOperation(createAuditTemplate, {input: newTemplate}))
}

function makeTree(checklists) {
    let top = [];

    let items = {}
    function getItem(id, value) {
        let obj = items[id]
        if(!obj) {
            obj = {};
            obj['lists'] = [];
            items[id] = obj;
        }
        if(value) {
            Object.assign(obj, value);
        }
        return obj;
    }

    checklists.forEach(element => {
        if(!element.parent){
            top.push(getItem(element.id, element))
        } else {
            let parent = getItem(element.parent);
            parent['lists'].push(getItem(element.id, element));
        }   
    });
    return top;
}
// Vuex state
const state = {
    all: [],
    checklistByTemplate: {}
}

// Vuex getters
const getters = {
    byId: (state) => (id) => state.all.find(t => t.id == id)
}

// Vuex actions
const actions = {
    async load({ commit, dispatch }/*, username*/) {
        try {
            let templates = await loadTemplates()

            console.log("templates", templates)
            commit('setTemplates', templates)
            dispatch('migrateTemplates', templates)
        }
        catch (err) {
            console.log('error listing templates: ', err)
        }
    },

    async delete({dispatch}, template) {
        let checklists = await loadAllChecklists(template.id)
        console.log("retrieved checklists for", template.id, checklists)
        await deleteChecklists(checklists)
        await delAuditTemplate(template.id)
        dispatch('load')
    },

    async migrateTemplates( _, templates) {
        templates.forEach(async(template) => {
            if(template.ver != 1) {
                console.log("Migrating", template.name)
                let newTemp = {
                    id: template.id,
                    ver: 1
                }
    
                if(template.checklists) {
                    let checklistPromises = template.checklists.items.map(c => {
                        return migrateChecklistTemplate(c.id, template.id)
                    })
                    for( var i = 0; i < checklistPromises.length; ++i) {
                        await checklistPromises[i]
                    }
                }
                
                await API.graphql(graphqlOperation(updateAuditTemplate, {input:newTemp}))
                console.log("updated", template.id, "to ver 1")
            }
        })
    },

    async share( _, {template, newOwner}) {
        console.log("sharing", template, newOwner)
        let checklists = await loadAllChecklists(template.id)
        console.log("retrieved checklis for", template.id, checklists)
        let newTemplate = {
            'id': uuidv4(),
            'owner': newOwner,
            'name': template.name,
            'desc': template.desc,
            'ver': 1
        }

        await copyChecklists(checklists, newTemplate.id, template.id, newOwner)
        console.log("saving new template", newTemplate)
        await copyAuditTemplate(newTemplate)
    },
    
    async loadChecklistsForTemplate({commit}, id) {
        console.log("loading checklists for", id);
        let checklists = await loadAllChecklists(id);
        console.log("unsorted", checklists);
        checklists = makeTree(checklists);
        console.log("set checklists", checklists);
        commit('setChecklists', {id, checklists});
    }
}

// Vuex mutations
const mutations = {
    setTemplates(state, templates) {
        state.all = templates
    },
    setChecklists(state, {id, checklists}) {
        let newTemplates = Object.assign({}, state.checklistByTemplate);

        newTemplates[id] = checklists;
        state.checklistByTemplate = newTemplates;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
